import { createActions } from 'redux-actions';

import types from 'state/settings/actionTypes';

const { settings } = createActions({
  [types.SET_COUNTRY_SETTINGS]: (countrySettings) => ({ countrySettings }),
  [types.SET_FEATURE_FLAGS]: (featureFlags) => ({ featureFlags }),
  [types.SET_INVITE_USER_MODAL_OPENED]: (open) => ({ open }),
});

export default settings;
